(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/start/assets/react/components/how-to-link.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/start/assets/react/components/how-to-link.js');

'use strict';

const Icon = svs.ui.ReactIcon;
const useFullscreenWidget = svs.eurojackpot.react.context.useFullscreenWidget;
const HowToLink = () => {
  const _useFullscreenWidget = useFullscreenWidget(),
    openFullscreen = _useFullscreenWidget.openFullscreen;
  const handleClick = e => {
    e.preventDefault();
    openFullscreen();
  };
  return React.createElement("div", {
    className: "eurojackpot-start-how-to-link-wrapper"
  }, React.createElement("a", {
    className: "how-to-link",
    href: "#",
    onClick: handleClick
  }, React.createElement("span", {
    className: "how-to-link-text"
  }, "S\xE5 funkar Eurojackpot"), ' ', React.createElement("span", null, React.createElement(Icon, {
    color: "@eurojackpot-100",
    icon: "information",
    size: "300"
  }))));
};
setGlobal('svs.eurojackpot.react.components', {
  HowToLink
});

 })(window);